import React from 'react';
import {StatisticBox} from '../../../../components';
import {useGetMessages} from '../../../../hooks';
import {Earnings} from '../../../../reducers/dashboard';
import EarningStatistic from './EarningStatistic';

export interface MyPayoutEligibilityProps {
    isRendering?: boolean;
    earnings: Earnings;
}

const MyPayoutEligibility: React.FC<MyPayoutEligibilityProps> = ({
    isRendering = false,
    earnings
}) => {
    const messages = useGetMessages({
        remainingBalanceTitle: 'epic.affiliate.closeAccount.remainingBalance.v2',
        payoutEligibilityTitle: 'epic.affiliate.earnings.my_earnings.tooltip.balance.title.v2',
        payoutEligibilitySubtitle: 'epic.affiliate.earnings.my_earnings.tooltip.balance.subtext.v2'
    });

    const showRemainingBalance = !isNaN(earnings.estimatedFinalPaymentAmount);
    const payoutEligibility = showRemainingBalance
        ? earnings.estimatedFinalPaymentAmount
        : Number(earnings.eligibleEarnings) || 0;

    const title = showRemainingBalance
        ? messages.remainingBalanceTitle
        : messages.payoutEligibilityTitle;

    return (
        <EarningStatistic
            isRendering={isRendering}
            title={title}
            tipTitle={messages.payoutEligibilitySubtitle}>
            <StatisticBox
                isRendering={isRendering}
                type={showRemainingBalance || payoutEligibility >= 100 ? 'currency' : 'percent'}
                header={payoutEligibility}
                CardHeaderProps={{titleTypographyProps: {variant: 'h2'}}}
            />
        </EarningStatistic>
    );
};

export default MyPayoutEligibility;
